import React, {useEffect,useContext,useState} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import DynamicSelect from "./DynamicSelect";
import generateUid from "../../utils/generateUid";
import DragTarget from "../Helpers/DragAndDrop/DragTarget";
import reactionCombiner from "../../utils/reactionCombiner";
import {custom} from "../../utils/linker";
import DropTarget from "../Helpers/DragAndDrop/DropTarget";
import DataExporter from "../Helpers/DataExporter";
import UniversalSelect from "./UniversalSelect";
import UniversalSelectFull from "./UniversalSelectFull";

function MultiDynamicSelectFull(props) {
  const store = useLocalObservable(() => ({
    noDragging:true,
    dragger_enter:false,
    dragging: {active:false,data:null},
    inited:false,
  }));
  const [comb,setComb]=useState(new reactionCombiner());
  const compStore=useContext(ComponentContext);
  if(!compStore.data || typeof compStore.data.length === 'undefined' ) {
    compStore.data=[];
  }

  let fieldSettings={};
  if(props.fieldSettings) {
    fieldSettings=JSON.parse(props.fieldSettings);
  }
  

  useEffect(() => {
    // mount
    comb.addReaction(()=>{
      return store.dragging.active;
    },(result)=>{
      checkDragging();
    });
    comb.addReaction(()=>{
      return store.dragger_enter;
    },(result)=>{
      checkDragging();
    })
    runInAction(()=>{
      store.inited=true;
    });

    return () => {
      // unmount
    }
  }, []);

  const checkDragging=()=>{
    runInAction(()=>{
      if(store.dragger_enter) {
        store.noDragging=false;
      } else {
        if(store.dragging.active) {
          store.noDragging=false;
        } else {
          store.noDragging=true;
        }
      }
    });
  };

  const getValueField=()=>{
    return fieldSettings.value_field || "value";
  };

  const addItem=()=>{
    compStore.data.push({[getValueField()]:'', focus:1, uid:generateUid(), sort:compStore.data.length+1 });
  };

  const deleteByIndex=(index)=>{
    runInAction(()=> {
      compStore.data.splice(index, 1);
      prepareSort();
    });
  };

  const findFieldByUid=(uid)=>{
    for(let i in compStore.data) {
      if(compStore.data[i].uid===uid) {
        return { index:parseInt(i), field:compStore.data[i]  };
      }
    }
    return null;
  };

  const prepareSort=()=>{

    for(let i in compStore.data) {
      const need=parseInt(i)+1;
      if(need!==compStore.data[i].sort) {
        compStore.data[i].sort = need;
      }
    }
  };

  const onDrop=(onWhat, what, position)=>{
    runInAction(()=>{
      if(onWhat.uid !== what.uid) {
        const whatOb = findFieldByUid(what.uid);
        if (whatOb) {
          const extracted = compStore.data.splice(whatOb.index, 1);
          const onWhatOb = findFieldByUid(onWhat.uid);
          if (position === "top") {
            compStore.data.splice(onWhatOb.index, 0, extracted[0]);
          }
          if (position === "bottom") {
            compStore.data.splice(onWhatOb.index+1, 0, extracted[0]);
          }
          prepareSort();
        }
      }
    });
  };

  console.log('fieldSettings', props.fieldSettings);

  return (
    <div>
      {compStore.data && compStore.data.length?compStore.data.map((item,index)=>{
        return (
          <div className={`mbottom5 pr ${store.dragging.data && item.uid === store.dragging.data.uid?"transp100":""} `}key={item.uid}>
            {store.dragging.active?(
              <>
                <DropTarget onDrop={(onWhat, what, position)=>{ onDrop(onWhat, what, position); }} item={item} position={"top"} dragLinker={custom(store, "dragging").linker} />
                <DropTarget onDrop={(onWhat, what, position)=>{ onDrop(onWhat, what, position); }} item={item} position={"bottom"} dragLinker={custom(store, "dragging").linker} />
              </>
            ):null}
            <DragTarget item={item} noDragging={store.noDragging} dragLinker={custom(store, "dragging").linker}>
              <div className={`up12 splice `}>
                <div className="cell s-shrink s-middle noselect">
                  <span className="mdi mdi-drag-vertical fs24 w4 b1-hover grab"
                    onMouseEnter={()=>{
                      runInAction(()=>{ store.dragger_enter=true; })
                    }}
                    onMouseLeave={()=>{
                      runInAction(()=>{ store.dragger_enter=false; })
                    }}
                  ></span>
                </div>
                <div className="cell s-auto">
                  <UniversalSelectFull deleteMe={()=>{ deleteByIndex(index); }} category={props.category} fieldSettings={props.fieldSettings} index={parseInt(index)} />
                </div>
              </div>
            </DragTarget>
          </div>
        )
      }):null}
      <span className="btn2 w100" onClick={()=>{ addItem(); }}><span className="w100 tac">Добавить</span></span>
      <DataExporter />
    </div>
  )
};

MultiDynamicSelectFull.defaultProps = {};

MultiDynamicSelectFull.propTypes = {}

export default observer(MultiDynamicSelectFull);
